/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import * as SelectPrimitive from "@radix-ui/react-select";
import type { ComponentRef } from "react";
import * as React from "react";

import { spacing } from "../../../../../global/emotion";
import { ChevronDownIcon } from "../../../_base/icons/Icon/NavigationIcons";

const scrollButtonStyle: Interpolation = {
  alignItems: "center",
  display: "flex",
  justifyContent: "center",
  paddingBottom: spacing.s,
  paddingTop: spacing.s,
};

type SelectScrollDownButtonProps = React.ComponentPropsWithoutRef<
  typeof SelectPrimitive.ScrollDownButton
>;

export const SelectScrollDownButton = React.forwardRef<
  ComponentRef<typeof SelectPrimitive.ScrollDownButton>,
  SelectScrollDownButtonProps
>((props, ref) => (
  <SelectPrimitive.ScrollDownButton
    ref={ref}
    css={scrollButtonStyle}
    {...props}
  >
    <ChevronDownIcon />
  </SelectPrimitive.ScrollDownButton>
));

SelectScrollDownButton.displayName = "SelectScrollDownButton";
